/*
 * Recreate this content with:
 *   cd public/awards
 *   ls * | awk 'BEGIN {print "export default {"} /:$/ {print "\x27"substr($1,1,length($1)-1)"\x27:["} /.svg$/ {print "\x27"$1"\x27,"} /^$/ {print "],"} END {print "]}"}'
 */
export default {
'candy-and-sweets-shop': [
'000-candy-1.svg',
'001-cake.svg',
'002-candy.svg',
'003-candy-cane.svg',
'004-birthday-cake.svg',
'007-chocolate-1.svg',
'008-lollipop.svg',
'010-jelly-beans.svg',
'015-doughnut.svg',
'016-lollipop-1.svg',
'017-macaroon.svg',
'018-cupcake.svg',
'020-cake-1.svg',
'024-candy-2.svg',
'026-candy-3.svg',
'028-candy-4.svg',
'029-candy-corn.svg',
'030-caramelized.svg',
'032-chocolate-egg.svg',
'033-sticks.svg',
'036-cookies.svg',
'038-chocolate-2.svg',
'039-sticks-1.svg',
'040-pie.svg',
'041-cinnamon-roll.svg',
'043-worm.svg',
'044-gingerbread.svg',
'046-candy-machine.svg',
'047-candy-jar.svg',
'049-cotton-candy.svg',
'050-gummy-bear.svg',
],
'ice-cream-shop': [
'000-ice-cream-9.svg',
'003-ice-cream-45.svg',
'006-table.svg',
'008-ice-cream-6.svg',
'013-ice-cream-41.svg',
'014-ice-cream-40.svg',
'015-ice-cream-39.svg',
'018-ice-cream-36.svg',
'019-ice-cream-35.svg',
'020-ice-cream-34.svg',
'022-scoop.svg',
'024-ice-cream-32.svg',
'025-apron.svg',
'026-ice-cream-30.svg',
'029-ice-cream-27.svg',
'031-cherry.svg',
'033-ice-cream-24.svg',
'035-ice-cream-22.svg',
'036-ice-cream-21.svg',
'037-ice-cream-20.svg',
'039-ice-cream-18.svg',
'040-ice-cream-17.svg',
'042-ice-cream-16.svg',
'044-ice-cream-14.svg',
'046-ice-cream-12.svg',
'049-ice-cream-43.svg',
'051-ice-cream-31.svg',
'054-bartender.svg',
'055-ice-cream-5.svg',
'058-ice-cream-2.svg',
'060-ice-cream.svg',
],
'knights-and-castles':[
'000-kingdom.svg',
'001-crown.svg',
'002-shield.svg',
'003-archery.svg',
'004-fanfare.svg',
'005-castle.svg',
'007-viking.svg',
'008-mace.svg',
'009-chest.svg',
'010-goblet.svg',
'012-crown-1.svg',
'013-excalibur.svg',
'017-standard.svg',
'019-quiver.svg',
'020-thor.svg',
'021-letter.svg',
'023-dagger.svg',
'025-torch.svg',
'028-banner.svg',
'029-armor.svg',
'030-axes.svg',
'031-joker.svg',
'032-ship.svg',
'037-tower.svg',
'039-spears.svg',
'041-throne.svg',
'042-helmet.svg',
'043-swords.svg',
'044-crossbow.svg',
'047-knight.svg',
'048-castle-1.svg',
'049-shield-1.svg',
],
'superhero': [,
'000-mask-3.svg',
'001-mask.svg',
'002-superhero.svg',
'003-help.svg',
'004-mask-1.svg',
'005-robot.svg',
'008-superheroe.svg',
'009-comic.svg',
'012-mask-2.svg',
'013-superheroe-1.svg',
'017-superhero-1.svg',
'019-superheroe-2.svg',
'020-watch.svg',
'021-mask-4.svg',
'022-belt.svg',
'025-superhero-2.svg',
'026-superhero-3.svg',
'029-mask-5.svg',
'031-mask-6.svg',
'032-superpower-1.svg',
'033-superheroe-3.svg',
'035-superheroe-4.svg',
'037-comic-1.svg',
'039-superhero-4.svg',
'040-mask-7.svg',
'043-superheroe-6.svg',
'046-superheroe-7.svg',
'047-mask-8.svg',
'048-shield-5.svg',
'049-superheroe-8.svg',
'050-cape.svg',
],
'ufo-and-aliens':[
'000-alien.svg',
'001-ufo.svg',
'002-spaceship.svg',
'004-telescope.svg',
'005-alien.svg',
'006-ufo.svg',
'007-blaster.svg',
'008-ufo.svg',
'009-spaceship.svg',
'010-alien.svg',
'011-spaceship.svg',
'012-alien.svg',
'013-alien.svg',
'014-rocket.svg',
'015-wormhole.svg',
'016-planet.svg',
'017-alien.svg',
'018-scan.svg',
'019-spaceship.svg',
'020-ufo.svg',
'021-alien.svg',
'022-robot.svg',
'023-ufo.svg',
'024-top secret.svg',
'025-raygun.svg',
'026-spaceship.svg',
'027-alien.svg',
'028-alien.svg',
'029-abduction.svg',
'030-spaceship.svg',
'031-alien.svg',
],
'zoo-animals':[
'000-lion.svg',
'001-zebra.svg',
'002-bamboo.svg',
'003-seal.svg',
'006-rabbit.svg',
'007-snake.svg',
'009-tree.svg',
'011-kangaroo.svg',
'012-panda-bear.svg',
'013-penguin.svg',
'014-koala.svg',
'015-cactus.svg',
'016-monkey.svg',
'017-goat.svg',
'021-elephant.svg',
'022-monkey.svg',
'023-hippo.svg',
'024-eagle.svg',
'026-frog.svg',
'027-peacock.svg',
'031-camel.svg',
'032-rhino.svg',
'033-turtle.svg',
'034-toucan.svg',
'036-fox.svg',
'037-crocodile.svg',
'041-owl.svg',
'042-gorilla.svg',
'044-ostrich.svg',
'046-giraffe.svg',
'047-hedgehog.svg',
]}